<div class="modal-header">
  <div class="modal-title">Scan Location</div>
  <div class="close" (click)="close()"></div>
</div>
<div class="modal-body">
  <ng-select
    [items]="location$ | async"
    bindValue="id"
    [typeahead]="locationInput$"
    [loading]="locationLoading"
    (change)="updateLocation($event)"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item?.location_name }} ({{
        item.parent_id === 0 ? 'GENERAL' : item?.parent?.location_name
      }})
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item?.location_name }} ({{
        item.parent_id === 0 ? 'GENERAL' : item?.parent?.location_name
      }})
    </ng-template>
  </ng-select>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Close</button>
</div>
